import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTokenInterceptor } from './interceptors/http-token.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { GraphQlModule } from './graphql/graphql.module';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ToastrModule } from 'ngx-toastr';
import { NotyfToastComponent } from '../shared/components/notyf.toast';

registerLocaleData(localeIt);

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        GraphQlModule,
        BsDropdownModule.forRoot(),
        ToastrModule.forRoot({
            // toastComponent: NotyfToastComponent,
            // toastClass: 'notyf confirm',
            // positionClass: 'notyf-container',
            maxOpened: 5,
            autoDismiss: true,
            newestOnTop: false,
            preventDuplicates: false,
            progressBar: false,
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpTokenInterceptor,
            multi: true,
        },
        {
            provide: LOCALE_ID,
            useValue: 'it',
        },
    ],
    declarations: [NotyfToastComponent],
    entryComponents: [NotyfToastComponent],
})
export class CoreModule {}
